<template>
  <div class="page-card">
    <h2 class="page-title">投放项管理</h2>

    <div class="toolbar">
      <div class="toolbar-left">
        <el-select v-model="query.positionId" clearable placeholder="资源位" style="width: 180px">
          <el-option v-for="item in positionOptions" :key="item.id" :label="item.positionName" :value="item.id" />
        </el-select>
        <el-input v-model="query.keyword" placeholder="标题关键字" clearable style="width: 200px" />
        <el-select v-model="query.targetType" clearable placeholder="目标类型" style="width: 140px">
          <el-option v-for="item in targetTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="query.status" clearable placeholder="状态" style="width: 140px">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-date-picker
          v-model="query.startAtFrom"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="开始时间起"
          style="width: 200px"
        />
        <el-date-picker
          v-model="query.startAtTo"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="开始时间止"
          style="width: 200px"
        />
        <el-button type="primary" @click="fetchData">查询</el-button>
      </div>
      <el-button v-if="canCreate" type="primary" @click="openDialog()">新建投放项</el-button>
    </div>

    <el-alert
      v-if="$route.query.positionName"
      :title="`当前正在查看资源位：${$route.query.positionName}`"
      type="info"
      :closable="false"
      style="margin-bottom: 16px"
    />

    <el-table :data="list" border>
      <el-table-column prop="positionName" label="资源位" min-width="160" />
      <el-table-column prop="title" label="投放标题" min-width="180" />
      <el-table-column label="目标类型" width="120">
        <template slot-scope="{ row }">
          {{ targetTypeLabel(row.targetType) }}
        </template>
      </el-table-column>
      <el-table-column prop="targetName" label="目标对象" min-width="180" />
      <el-table-column label="投放方式" width="120">
        <template slot-scope="{ row }">
          {{ recommendTypeLabel(row.recommendType) }}
        </template>
      </el-table-column>
      <el-table-column label="权重" width="160">
        <template slot-scope="{ row }">
          <div class="sort-cell">
            <el-input-number v-model="row.sortNo" :min="0" size="mini" controls-position="right" />
            <el-button v-if="canSort" type="text" @click="submitSort(row)">提交</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="startAt" label="开始时间" width="170" />
      <el-table-column prop="endAt" label="结束时间" width="170" />
      <el-table-column label="状态" width="120">
        <template slot-scope="{ row }">
          <el-tag :type="statusTagType(row.status)">
            {{ statusLabel(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" width="170" />
      <el-table-column label="操作" width="220">
        <template slot-scope="{ row }">
          <el-button v-if="canUpdate" type="text" @click="openDialog(row)">编辑</el-button>
          <el-button
            v-if="row.status !== 2 && canEnable"
            type="text"
            @click="changeStatus(row, 'enable')"
          >
            启用
          </el-button>
          <el-button
            v-if="row.status === 2 && canDisable"
            type="text"
            @click="changeStatus(row, 'disable')"
          >
            下线
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="form.id ? '编辑投放项' : '新建投放项'" :visible.sync="dialogVisible" width="760px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="资源位" prop="positionId">
          <el-select v-model="form.positionId" placeholder="请选择资源位" style="width: 100%">
            <el-option v-for="item in positionOptions" :key="item.id" :label="item.positionName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="目标类型" prop="targetType">
          <el-select v-model="form.targetType" placeholder="请选择目标类型" style="width: 100%" @change="handleTargetTypeChange">
            <el-option v-for="item in targetTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.targetType !== 5" label="目标对象" prop="targetId">
          <el-select
            v-model="form.targetId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入关键字搜索"
            :remote-method="fetchTargetOptions"
            :loading="targetLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in targetOptions"
              :key="item.id"
              :label="item.subtitle ? `${item.name} (${item.subtitle})` : item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="投放标题" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="投放副标题">
          <el-input v-model="form.subtitle" />
        </el-form-item>
        <el-form-item label="封面图">
          <el-input v-model="form.imageUrl" />
        </el-form-item>
        <el-form-item label="跳转链接" prop="jumpUrl">
          <el-input v-model="form.jumpUrl" />
        </el-form-item>
        <el-form-item label="角标文案">
          <el-input v-model="form.buttonText" />
        </el-form-item>
        <el-form-item label="投放方式">
          <el-select v-model="form.recommendType" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in recommendTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="排序权重">
          <el-input-number v-model="form.sortNo" :min="0" style="width: 100%" />
        </el-form-item>
        <el-form-item label="开始时间" prop="startAt">
          <el-date-picker
            v-model="form.startAt"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择开始时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="form.endAt"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择结束时间"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="扩展配置">
          <el-input v-model="form.extJson" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { hasPermission } from '../../../utils/auth'
import { getOpsResourcePositions } from '../../../api/opsResourcePosition'
import {
  createOpsResourceItem,
  disableOpsResourceItem,
  enableOpsResourceItem,
  getOpsResourceItems,
  sortOpsResourceItem,
  updateOpsResourceItem
} from '../../../api/opsResourceItem'
import {
  getArtistTargets,
  getMerchantTargets,
  getNoticeTargets,
  getTaxonomyTargets,
  getTopicTargets
} from '../../../api/opsResourceTarget'

const targetTypeOptions = [
  { label: '通告', value: 1 },
  { label: '商家', value: 2 },
  { label: '艺人', value: 3 },
  { label: '专题', value: 4 },
  { label: '自定义页面', value: 5 },
  { label: '分类标签', value: 7 }
]

const recommendTypeOptions = [
  { label: '人工推荐', value: 1 },
  { label: '规则推荐', value: 2 },
  { label: '付费推荐', value: 3 }
]

const statusOptions = [
  { label: '待生效', value: 1 },
  { label: '生效中', value: 2 },
  { label: '已下线', value: 3 },
  { label: '已过期', value: 4 }
]

function getDefaultForm() {
  return {
    id: '',
    positionId: '',
    targetType: undefined,
    targetId: '',
    title: '',
    subtitle: '',
    imageUrl: '',
    jumpUrl: '',
    buttonText: '',
    recommendType: 1,
    sortNo: 0,
    startAt: '',
    endAt: '',
    extJson: ''
  }
}

export default {
  name: 'OpsResourceItemPage',
  data() {
    return {
      list: [],
      positionOptions: [],
      targetOptions: [],
      targetLoading: false,
      query: {
        positionId: '',
        keyword: '',
        targetType: undefined,
        status: undefined,
        startAtFrom: '',
        startAtTo: ''
      },
      dialogVisible: false,
      form: getDefaultForm(),
      targetTypeOptions,
      recommendTypeOptions,
      statusOptions,
      rules: {
        positionId: [{ required: true, message: '请选择资源位', trigger: 'change' }],
        targetType: [{ required: true, message: '请选择目标类型', trigger: 'change' }],
        targetId: [{ required: true, message: '请选择目标对象', trigger: 'change' }],
        title: [{ required: true, message: '请输入投放标题', trigger: 'blur' }],
        startAt: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        jumpUrl: [{
          validator: (rule, value, callback) => {
            if (this.form.targetType === 5 && !value) {
              callback(new Error('自定义页面必须填写跳转链接'))
              return
            }
            callback()
          },
          trigger: 'blur'
        }]
      }
    }
  },
  computed: {
    canCreate() {
      return hasPermission('ops_resource_item:create')
    },
    canUpdate() {
      return hasPermission('ops_resource_item:update')
    },
    canEnable() {
      return hasPermission('ops_resource_item:enable')
    },
    canDisable() {
      return hasPermission('ops_resource_item:disable')
    },
    canSort() {
      return hasPermission('ops_resource_item:sort')
    }
  },
  created() {
    if (this.$route.query.positionId) {
      this.query.positionId = String(this.$route.query.positionId)
    }
    this.fetchPositions()
    this.fetchData()
  },
  methods: {
    targetTypeLabel(value) {
      const target = this.targetTypeOptions.find(item => item.value === value)
      return target ? target.label : '-'
    },
    recommendTypeLabel(value) {
      const target = this.recommendTypeOptions.find(item => item.value === value)
      return target ? target.label : '-'
    },
    statusLabel(value) {
      const target = this.statusOptions.find(item => item.value === value)
      return target ? target.label : '-'
    },
    statusTagType(value) {
      if (value === 2) return 'success'
      if (value === 1) return 'warning'
      if (value === 3) return 'info'
      return 'danger'
    },
    async fetchPositions() {
      this.positionOptions = await getOpsResourcePositions({})
    },
    async fetchData() {
      const params = {
        ...this.query,
        positionId: this.query.positionId || undefined
      }
      this.list = await getOpsResourceItems(params)
    },
    async fetchTargetOptions(keyword = '') {
      if (!this.form.targetType || this.form.targetType === 5) {
        this.targetOptions = []
        return
      }
      this.targetLoading = true
      const params = { keyword }
      try {
        if (this.form.targetType === 1) {
          this.targetOptions = await getNoticeTargets(params)
        } else if (this.form.targetType === 2) {
          this.targetOptions = await getMerchantTargets(params)
        } else if (this.form.targetType === 3) {
          this.targetOptions = await getArtistTargets(params)
        } else if (this.form.targetType === 4) {
          this.targetOptions = await getTopicTargets(params)
        } else if (this.form.targetType === 7) {
          this.targetOptions = await getTaxonomyTargets(params)
        } else {
          this.targetOptions = []
        }
      } finally {
        this.targetLoading = false
      }
    },
    handleTargetTypeChange() {
      this.form.targetId = ''
      this.targetOptions = []
      this.fetchTargetOptions('')
    },
    openDialog(row) {
      this.dialogVisible = true
      this.form = row
        ? {
            ...getDefaultForm(),
            ...row,
            id: row.id ? String(row.id) : '',
            positionId: row.positionId ? String(row.positionId) : '',
            targetId: row.targetId ? String(row.targetId) : ''
          }
        : {
            ...getDefaultForm(),
            positionId: this.query.positionId || ''
          }
      if (this.form.targetType && this.form.targetType !== 5) {
        this.fetchTargetOptions('')
      }
    },
    submitForm() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        const payload = {
          ...this.form,
          positionId: this.form.positionId,
          targetId: this.form.targetType === 5 || !this.form.targetId ? 0 : this.form.targetId
        }
        if (this.form.id) {
          await updateOpsResourceItem(this.form.id, payload)
        } else {
          await createOpsResourceItem(payload)
        }
        this.dialogVisible = false
        await this.fetchData()
      })
    },
    async changeStatus(row, type) {
      if (type === 'enable') {
        await enableOpsResourceItem(row.id)
      } else {
        await disableOpsResourceItem(row.id)
      }
      await this.fetchData()
    },
    async submitSort(row) {
      await sortOpsResourceItem(row.id, { sortNo: row.sortNo })
      await this.fetchData()
    }
  }
}
</script>

<style scoped>
.toolbar-right {
  display: flex;
  gap: 12px;
}

.sort-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
